{
    "TelephoneserverLabel": "Telefonserver:",
    "PartitionsLabel": "Partition(en):",
    "ScopeFiltering_SectionHeader": "Bereichsfilterung",
    "NAME": "ScopeFiltering"
}